export default __webpack_public_path__ + "static/media/imgpost5.668c9aef.jpg";